// 是否更新本次版本
const IS_UPDATE = {
  status: true,
  // 最近一次
  date: "2023-09-14",
};
export default {
  IS_UPDATE,
};
